import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { EditorState } from 'lexical';
import { RefObject, useEffect } from 'react';

import { convertToMarkdownString } from '@/components/TextEditor/TextEditor.utils';
import { markdownTransformers } from '@/components/TextEditor/transformers';

import { canonicalizeSummaryForDirtyCheck } from '../../documents.utils';

export function SummaryContentChangePlugin({
  baselineRef,
  onChange,
}: {
  baselineRef: RefObject<string | null>;
  onChange: (content: string, isDirty: boolean) => void;
}) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const update = (editorState: EditorState) => {
      const content = editorState.read(() =>
        convertToMarkdownString({
          transformers: markdownTransformers,
          shouldPreserveNewLines: true,
        })
      );
      const canonicalContent = canonicalizeSummaryForDirtyCheck(content);
      // Read the parsed editor state, not the raw Markdown emitted on mount.
      // The parent keeps this baseline if the split-screen layout remounts us.
      baselineRef.current ??= canonicalContent;
      onChange(content, canonicalContent !== baselineRef.current);
    };

    update(editor.getEditorState());
    return editor.registerUpdateListener(({ editorState }) => {
      update(editorState);
    });
  }, [baselineRef, editor, onChange]);

  return null;
}
